// extracted by mini-css-extract-plugin
export default {"numberCard":"NumberCard_numberCard__VetXA","number":"NumberCard_number__svpAG","text":"NumberCard_text__qGoVQ","helpText":"NumberCard_helpText__4Tnnv"};